module.exports = __webpack_public_path__ + "img/vitamina-A.d722ad5b.png";